import { stores as initialState } from 'flux/initialState';
import { stores as actions } from 'flux/actions';

export default function (state = initialState, action) {
  const { types } = actions;

  switch (action.type) {
    case types.SET_CURRENT_STORE: {
      const { storeId } = action.payload;
      return { ...state, current: storeId };
    }
    case types.RESET: {
      const { resetState } = action.payload;
      return { ...state, ...resetState, fetched: true };
    }
    case types.UPDATE_STORE_OPENING_INFOS: {
      const { storeId, storeHours } = action.payload;
      return {
        ...state,
        list: {
          ...state.list,
          [storeId]: { ...state.list[storeId], storeHours },
        },
      };
    }
    case types.UPDATE_STORES_BY_LOCATION: {
      const { flyers } = action.payload;

      const { list: flyersList } = flyers;
      const stores = { ...state };

      for (const flyer of Object.values(flyersList)) {
        for (const [storeId, store] of Object.entries(flyer.stores)) {
          stores.list[storeId] = store;

          if (store._id) stores.idBy_id[store._id] = store.id;

          const customerCode = store.extras?.customer_code;
          if (customerCode) {
            stores.idByCustomerCode[customerCode] = store.id;
          }
        }
      }
      return { ...state, ...stores };
    }
    default:
      return state;
  }
}
